var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({ content: _vm.tooltipText }),expression:"{ content: tooltipText }"}],staticClass:"base-button",class:[{ 'is-full-width': _vm.isFullWidth }, `variant-${_vm.variant}`]},[(_vm.href !== '')?_c('a',{staticClass:"base-button__element",class:{
      'has-icon-left': _vm.hasIconLeft,
      'has-icon-right': _vm.hasIconRight,
      'is-outlined': _vm.isOutlined,
      'is-small': _vm.isSmall,
      'is-large': _vm.isLarge,
      'is-ai': _vm.isAi,
      'is-square': _vm.isSquare,
      'is-grey': _vm.isGrey,
    },attrs:{"href":_vm.href,"target":_vm.targetBlank ? '_blank' : '_self',"rel":_vm.targetBlank ? 'noopener noreferrer' : null}},[_vm._t("default",function(){return [_vm._v("Text")]})],2):(_vm.to !== '')?_c('router-link',{staticClass:"base-button__element",class:{
      'has-icon-left': _vm.hasIconLeft,
      'has-icon-right': _vm.hasIconRight,
      'is-outlined': _vm.isOutlined,
      'is-small': _vm.isSmall,
      'is-large': _vm.isLarge,
      'is-ai': _vm.isAi,
      'is-square': _vm.isSquare,
      'is-grey': _vm.isGrey,
    },attrs:{"to":_vm.to}},[_vm._t("default",function(){return [_vm._v("Text")]})],2):_c('button',{staticClass:"base-button__element",class:{
      'has-icon-left': _vm.hasIconLeft,
      'has-icon-right': _vm.hasIconRight,
      'is-loading': _vm.isLoading,
      'is-outlined': _vm.isOutlined,
      'is-transparent': _vm.isTransparent,
      'is-danger': _vm.isDanger,
      'is-ai': _vm.isAi,
      'is-small': _vm.isSmall,
      'is-large': _vm.isLarge,
      'is-underline': _vm.isUnderline,
      'is-square': _vm.isSquare,
      'is-grey': _vm.isGrey,
    },attrs:{"disabled":_vm.disabled,"type":_vm.type,"role":"button"},on:{"mousedown":function($event){$event.preventDefault();},"pointerdown":function($event){$event.preventDefault();}}},[_vm._t("default",function(){return [_vm._v("Text")]})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }